import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/site-chrome";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Kebijakan Privasi — jasasebar.com" },
      {
        name: "description",
        content: "Kebijakan privasi jasasebar.com: data yang kami kumpulkan, penggunaan, dan hak Anda.",
      },
      { property: "og:title", content: "Kebijakan Privasi — jasasebar.com" },
      {
        property: "og:description",
        content: "Kebijakan privasi jasasebar.com: data yang kami kumpulkan, penggunaan, dan hak Anda.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://jasasebar.com/privacy" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://jasasebar.com/privacy" }],
  }),
  component: PrivacyPage,
});

const sections = [
  {
    title: "1. Data yang Kami Kumpulkan",
    body: "Kami mengumpulkan: (a) data akun dari Google login (nama, email, foto profil); (b) data listing yang Anda kirimkan (nama, tautan, kategori); (c) data transaksi pembayaran (nomor pesanan, jumlah, status); serta (d) data teknis seperti alamat IP dan perangkat untuk keamanan dan anti-kecurangan.",
  },
  {
    title: "2. Penggunaan Data",
    body: "Data digunakan untuk menjalankan layanan papan promosi: menampilkan listing, memproses pembayaran, mengelola peringkat, mengirim notifikasi status transaksi dan referral (bila Anda mengaktifkannya), serta mencegah penyalahgunaan.",
  },
  {
    title: "3. Cookie dan Pelacakan",
    body: "Kami menggunakan cookie untuk sesi login dan penyimpanan preferensi. Kami juga mencatat event analitik (klik, bagikan, UTM) secara agregat untuk memahami kinerja papan. Iklan pihak ketiga (Google AdSense) dapat menggunakan cookie sesuai kebijakan Google.",
  },
  {
    title: "4. Berbagi dengan Pihak Ketiga",
    body: "Kami tidak menjual data pribadi. Data dibagikan hanya kepada penyedia layanan yang membantu operasional: penyedia pembayaran (untuk memproses transaksi), penyedia email (untuk notifikasi), dan platform periklanan Google.",
  },
  {
    title: "5. Keamanan Data",
    body: "Kami menerapkan pembatasan akses berbasis peran, enkripsi transmisi (HTTPS), rate limiting, dan pencatatan audit akses admin. Kata sandi tidak pernah kami simpan — autentikasi sepenuhnya melalui Google.",
  },
  {
    title: "6. Retensi",
    body: "Data akun dan transaksi disimpan selama akun aktif atau sebagaimana diwajibkan hukum. Anda dapat meminta penghapusan akun dengan menghubungi kami.",
  },
  {
    title: "7. Hak Anda",
    body: "Anda berhak mengakses, memperbaiki, mengunduh, dan meminta penghapusan data pribadi Anda, serta menarik persetujuan notifikasi kapan saja melalui pengaturan di dashboard.",
  },
  {
    title: "8. Anak di Bawah Umur",
    body: "Layanan tidak ditujukan untuk anak di bawah 18 tahun. Kami tidak secara sengaja mengumpulkan data anak.",
  },
  {
    title: "9. Perubahan Kebijakan",
    body: "Kebijakan ini dapat diperbarui; perubahan material akan diumumkan di situs. Versi terbaru selalu tersedia di halaman ini.",
  },
  {
    title: "10. Kontak",
    body: "Untuk pertanyaan privasi atau permintaan terkait data, hubungi kami melalui email dukungan yang tercantum di situs.",
  },
];

function PrivacyPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="hero-canvas">
        <div className="mx-auto max-w-3xl px-4 py-16">
          <h1 className="font-display text-4xl font-semibold">Kebijakan Privasi</h1>
          <p className="mt-3 text-muted-foreground">
            Terakhir diperbarui: September 2026. Kami menghargai privasi Anda.
          </p>
          <div className="mt-10 space-y-6">
            {sections.map((s) => (
              <section key={s.title} className="surface-card p-6">
                <h2 className="font-display text-lg font-semibold">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
